$(function(){

  // Hide element depending on checkbox
  $('[data-hide-by-checkbox]').each(function(){
    let $area = $(this);
    let $checkbox = $($(this).data('hide-by-checkbox'));

    let activate = function(){
      let checked = $(this).is(':checked');
      $area.toggleClass('d-none', checked)
    };

    $checkbox.change(activate);
    $checkbox.trigger('change');
  });

  $('[data-show-by-checkbox]').each(function(){
    let $area = $(this);
    let $checkbox = $($(this).data('show-by-checkbox'));

    let activate = function(){
      let checked = $(this).is(':checked');
      $area.toggleClass('d-none', !checked)
      $area.find(':input').each(function() {
        $(this).prop('disabled', !checked)
      })
    };

    $checkbox.change(activate);
    $checkbox.trigger('change');
  });

  // Hide element depending on checkbox
  $('[data-hide-by-select]').each(function(){
    let $area = $(this);
    let $select = $($(this).data('hide-by-select'));
    let select_value = $(this).data('hide-by-select-value');

    let activate = function(){
      let value = $(this).val();
      $area.toggleClass('d-none', value === select_value)
    };

    $select.change(activate);
    $select.trigger('change');
  });

  $('[data-toggle="tooltip"]').tooltip();


  // Focus first input or first input with error
  $('.fn-slick-form-focus form').each(function() {
    let focusedElement = $('.is-invalid:input:visible').not(':button').first();
    if (focusedElement.length === 0) {
      focusedElement = $(':input:visible').not(':button').first();
    }

    // Select text on focus
    focusedElement.on('focus', function () {
      // Delay sightly to allow focus to "stick" before selecting.
      setTimeout(function(){ focusedElement.select(); }, 50);
    });

    // Focus the first input of form
    focusedElement.focus()
  });

  // This is only needed one place.
  // Don't know how to utilise
  // 'fn-slick-form-focus' on election config forms
  // without it jumping to bottom of page.
  $('.stay-top').each(function() {
    $(document).scrollTop(0);
  });
});
